import SmallMultiple from "./SmallMultiple/SmallMultipleMain";

const PvSmallMultipleLocation = ({ title, location_key, colors }) => {
  const items = [
        {
            title: "< 10 kWp", 
            explanationText: "Diese Kategorie umfasst Photovoltaikanlagen mit einer installierten Leistung bis 10 kWp. Üblicherweise sind das kleine PV-Anlagen auf Einfamilienhäusern oder Balkonkraftwerke im privaten Bereich.", 
            size_category: "Power_0_10"
          },
          { 
            title: "10-30 kWp", 
            explanationText: "Diese Kategorie umfasst Photovoltaikanlagen mit einer installierten Leistung zwischen 10 und 30 kWp. Das sind beispielsweise PV-Anlagen auf größeren Wohngebäuden, kleinen Gewerbebauten oder Nebengebäuden.", 
            size_category: "Power_10_30"  
          },
          { 
            title: "30-100 kWp", 
            explanationText: "Diese Kategorie umfasst Photovoltaikanlagen mit einer installierten Leistung zwischen 30 und 100 kWp. Diese Größen sind typisch für gewerbliche Dächer, landwirtschaftliche Betriebe oder kleinere Freiflächenanlagen.", 
            size_category: "Power_30_100"  
          },
          { 
            title: "100-1000", 
            explanationText: "Diese Kategorie umfasst Photovoltaikanlagen mit einer installierten Leistung zwischen 100 und 1000 kWp. Typischerweise sind das große gewerbliche Dächer oder kleinere Freiflächenanlagen.", 
            size_category: "Power_100_1000"  
          },
          { 
            title: ">= 1000", 
            explanationText: "Diese Kategorie umfasst Photovoltaikanlagen mit einer installierten Leistung ab 1000 kWp oder 1 MWp. Dies sind Großanlagen oder Freiflächenanlagen zur Netzeinspeisung oder als Teil von Solarparks.", 
            size_category: "Power_1000"  
          },
    ];
    
  return (
    <>
      <h3 className="text-xl mt-10 mb-2 font-semibold text-center">{title}</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 rounded-lg">
        {items.map(({ size_category, title, explanationText }, index) => (
          <div key={index} className="text-center flex flex-col items-center">
            <SmallMultiple
              textData={{
                summary: title,
                popoverText: explanationText,
              }}
              donutSpec={title}
              location_key={location_key}
              energySource={"pv"} // relevant for api-call
              unit={"MWp"}
              smallMultipleType="size" // relevant for api-call
              LineChartTitle={'Installierte Leistung in MWp'}
              category={size_category}
              colors={colors}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default PvSmallMultipleLocation;
